import React from 'react';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ArticleDisclaimer = _ref => {
  let {
    adSupported = false
  } = _ref;
  return /*#__PURE__*/_jsx("small", {
    className: styles.disclaimer,
    children: adSupported ? /*#__PURE__*/_jsxs(_Fragment, {
      children: ["Read about our", ' ', /*#__PURE__*/_jsx("a", {
        href: "/advertising-disclosure/",
        children: "advertising disclosure"
      })]
    }) : 'We independently review recommendations. If you buy through our links, we may earn a commission.'
  });
};

export default ArticleDisclaimer;